/**
 * German Translations
 * Tyska översättningar för DQFleet.
 * Filen skrivs om av scripts/i18n/generate-locale-fill.ts.
 */

export const translationsDe: Record<string, any> = {};
